import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { orientaionLoading: true, orientaionData: {}, orientaionError: false };

export function orientationReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_ORIENTATION_DATA:
            return {
                orientaionLoading: true,
                orientaionData: '',
                orientaionError: false
            };
        case AnalyzeConstants.RECEIVE_ORIENTATION_DATA:
            return {
                orientaionLoading: false,
                orientaionData: action.res,
                orientaionError: false
            };
        case AnalyzeConstants.ORIENTATION_DATA_ERROR:
            return {
                orientaionLoading: false,
                orientaionData: '',
                orientaionError: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/orientation.reducer.js